import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { PageHeader } from "@/components/common";
import { MovementForm } from "@/components/MovementForm";
import { MovementHistory } from "@/components/MovementHistory";
import { ScanHub } from "@/components/ScanHub";

export default function Movements() {
  const [params] = useSearchParams();
  const [tab, setTab] = useState(params.get("tab") === "historique" ? "historique" : "nouveau");
  const [refresh, setRefresh] = useState(0);
  useEffect(() => { if (params.get("tab") === "historique") setTab("historique"); }, [params]);

  return (
    <div data-testid="movements-page">
      <PageHeader title="Mouvements" subtitle="Entrées, sorties, ajustements d'inventaire et sorties de kits." testid="movements-title" />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-6 h-12">
          <TabsTrigger value="nouveau" className="h-10 px-5" data-testid="movements-tab-new">Nouveau mouvement</TabsTrigger>
          <TabsTrigger value="historique" className="h-10 px-5" data-testid="movements-tab-history">Historique</TabsTrigger>
        </TabsList>
        <TabsContent value="nouveau">
          <MovementForm initialType={params.get("type")} initialCode={params.get("code")} onDone={() => setRefresh((r) => r + 1)} />
        </TabsContent>
        <TabsContent value="historique"><MovementHistory refresh={refresh} /></TabsContent>
      </Tabs>
      <ScanHub onChanged={() => setRefresh((r) => r + 1)} />
    </div>
  );
}
